require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./matriel-pdagogique-pour-gymnasiens-2-0-5-0.json") })
        }
      }, "path---matriel-pdagogique-pour-gymnasiens-2-0-5-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---matriel-pdagogique-pour-gymnasiens-2-0-5-0!./.cache/json/matriel-pdagogique-pour-gymnasiens-2-0-5-0.json
// module id = 491
// module chunks = 231608221292675